<template>
  <v-main class="white">
    <v-card-title class="justify-center" style="height: 100%">
      <img :src="`${this.customBasePath}/logo.png`"/>
    </v-card-title>
  </v-main>
</template>

<script>
import {settingsMixin} from '@/utils/settings-mixin'
import {eventMixin} from '@/utils/event-mixin'
import {layoutMixin} from '@/utils/layout-mixin'
import {qrLoginMixin} from '@/utils/qrlogin-mixin'
import {onboardingMixin} from '@/utils/onboarding-mixin'

export default {
  components:{
  },
  mixins: [settingsMixin,layoutMixin,eventMixin,qrLoginMixin,onboardingMixin],
  data(){
    return{
    }
  },
  watch:{
    isLoggedIn: {
      handler(token) {
        if (token) {
          this.checkPerson(token)
        } else {
          this.afterCheck(token)
        }
      },
      immediate: true
    }
  },
  computed: {
  },
  methods:{

    checkPerson(token) {
      this.getPerson().then(()=> {
        this.afterCheck(token);
      }).catch((ex) => {
        console.log('getPerson error');
        console.error(ex);
        this.afterCheck();
      });
    },
    afterCheck(token) {
      if (!!token) {
        this.checkEvent();
      } else {
        this.doLogin();
      }
    },
    checkEvent() {
      if (this.hasQRData()) {
        let qrAtStart = this.getQrData();
        if (this.isAutoLogin() || this.isTeamLogin()|| this.isGuestLogin() ) {
          this.goToCheckLogin({'d':qrAtStart});
        } else {
          this.goToEventList({'d':qrAtStart});
        }
      } else {
        this.doNormalGoToEvent()
      }
    },
    doNormalGoToEvent() {
      // resume the current event, otherwise land like the native app (card / main event / list)
      this.landOnStart();
    },
    doLogin(){
      if (this.hasQRData()) {
        this.goToLogin({'d':this.getQrData()});
      } else {
        this.goToLogin();
      }
    },
  }
}
</script>

<style scoped>

</style>
